<template>
  <!-- deprecated by DropdownSearch component -->
  <div class="flex flex-col gap-y-1">
    <div class="w-full flex flex-col md:flex-row gap-x-4 gap-y-1 md:items-center">
      <label :for="fieldName" class="w-full md:w-1/3">
        {{ label }}
        <span v-if="isRequired" class="text-brand-red ps-1">*</span>
      </label>
      <div class="w-full flex has-[:disabled]:bg-slate-200">
        <div
          :class="[{ 'border-s-4 border-s-primary': isRequired }]"
          class="relative p-1 w-4/12 md:w-2/12 flex items-center has-[:disabled]:bg-slate-200 bg-gray-100 border border-brand-grayblue-300 rounded-s-sm"
        >
          <input
            :disabled="isDisabled"
            type="text"
            class="w-full ps-3 py-1 border border-brand-grayblue-300 outline-none focus:border-primary"
            v-model="textModel"
            @blur="onValueBlur"
          />
        </div>
        <div class="w-8/12 md:w-10/12 flex items-center border border-brand-grayblue-300">
          <tippy
            theme="light-border"
            :on-click-outside="handleBlur"
            interactive
            placement="bottom-start"
            trigger="focus click"
            class="w-full flex items-center"
          >
            <div class="w-full flex justify-between px-3">
              <button
                :disabled="isDisabled"
                class="tippy__trigger w-full text-start line-clamp-1 truncate outline-none"
              >
                <span v-if="selectedValue?.label" class="w-full">
                  {{ selectedValue?.label }}
                </span>
                <span v-else class="w-full text-gray-400">
                  {{ placeholder }}
                </span>
              </button>
              <span>
                <FontAwesomeIcon :icon="faCaretDown" class="text-brand-black-secondary" />
              </span>
            </div>
            <template #content="{ hide }">
              <div class="tippy-content__container w-full p-0.5">
                <div class="w-full flex flex-col gap-y-1">
                  <div class="px-1.5 pt-1">
                    <input
                      v-model="searchValue"
                      type="text"
                      class="w-full ps-3 py-1.5 rounded-sm border border-brand-grayblue-300 outline-none focus:border-primary"
                    />
                  </div>
                  <div class="max-h-[12rem] h-full overflow-y-auto">
                    <ul class="divide-y pb-2">
                      <li v-for="(option, key) in filteredOptions" :key="key" class="">
                        <button
                          class="ps-3 py-1.5 hover:bg-gray-100 w-full text-start"
                          @click="
                            () => {
                              hide()
                              onSelection(option)
                            }
                          "
                        >
                          {{ option.label }}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </template>
          </tippy>
        </div>
      </div>
    </div>
    <div v-if="hasError" class="w-full flex flex-col md:flex-row gap-x-4 gap-y-1 md:items-center">
      <div class="w-full md:w-1/3"></div>
      <span class="w-full pt-[2px] text-brand-red ltr:font-sans text-xs">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { Tippy } from 'vue-tippy'
import { toRef, ref, onMounted, computed } from 'vue'
import { useField } from 'vee-validate'
import Fuse from 'fuse.js'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'

const props = defineProps({
  fieldName: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  isRequired: Boolean,
  isDisabled: Boolean,

  placeholder: String,

  options: {
    type: Array,
    required: true
  },
  defaultValue: {
    type: Object
  },
  rules: Object,
  fuzzyKeywords: {
    type: Array,
    default: () => ['label']
  }
})

const textModel = ref()
const selectedValue = ref()
const searchValue = ref()
const fieldName = toRef(props, 'fieldName')

const fuse = new Fuse(props.options, {
  includeScore: true,
  threshold: 0.2,
  keys: props.fuzzyKeywords
})

onMounted(() => {
  if (props.defaultValue) {
    const defaultOption = props.options.find((o) => o.value == props.defaultValue)
    selectedValue.value = defaultOption
    handleChange(defaultOption.value)
    textModel.value = defaultOption.value
  }
})

const { errorMessage, handleChange, handleBlur, meta } = useField(fieldName, props.rules, {
  initialValue: props.initialValue
})

const hasError = computed(() => errorMessage.value && meta.touched)

const filteredOptions = computed(() => {
  if (!searchValue.value) return props.options
  const result = fuse.search(searchValue.value)

  return result.map((r) => r.item)
})

const onSelection = (option) => {
  selectedValue.value = option
  handleChange(option.value)
  textModel.value = option.value
}

// watch(textModel, () => {
//   handleBlur()

//   // TODO: search options with textModel.value
// })

const onValueBlur = () => {
  if (!textModel.value) return
  const result = props.options.find((o) => o.value.toUpperCase() == textModel.value.toUpperCase())
  if (!result) {
    textModel.value = null
    return
  }

  selectedValue.value = result
  handleChange(result.value.toUpperCase())
}
</script>

<style lang="scss" scoped></style>
